<cerrix-loader [cerrixTab]="tab"></cerrix-loader>

@if (about) {
    <div class="text-center" *transloco="let t; read: 'about'">
        @if (halloweenLogo) {
            <img
                class="about-logo"
                [title]="t('happyHalloween')"
                src="/assets/img/halloween.gif"
                alt="Cerrix-Logo"
            />
        } @else {
            <img class="about-logo" src="/assets/img/logo.svg" alt="Cerrix-Logo" />
        }
        <div>
            <b>{{ about.product }}</b>
        </div>
        <table>
            <tbody>
                <tr>
                    <td colspan="2"><hr /></td>
                </tr>
                <tr>
                    <td>{{ t("versionNumber") }}</td>
                    <td>{{ about.version }}</td>
                </tr>
                <tr>
                    <td>{{ t("versionDate") }}</td>
                    <td>{{ about.datePublished }} <small>{{ t("timezoneLabel") }}</small></td>
                </tr>
                <tr>
                    <td colspan="2"><hr /></td>
                </tr>
            </tbody>
        </table>
    </div>
}
